module.exports = __webpack_public_path__ + "static/img/ziranzaihai.c63fbd88.png";